import { render, staticRenderFns } from "./Shippers.vue?vue&type=template&id=e0896380&scoped=true&"
import script from "./Shippers.vue?vue&type=script&lang=js&"
export * from "./Shippers.vue?vue&type=script&lang=js&"
import style0 from "./Shippers.vue?vue&type=style&index=0&id=e0896380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0896380",
  null
  
)

export default component.exports